/* eslint-disable max-len */
/* eslint-disable no-redeclare */
// update Query/Filter
 
export const UPDATE_SORT = "UPDATE_SORT";
export type UPDATE_SORT = typeof UPDATE_SORT;

export const UPDATE_API_URLS = "UPDATE_API_URLS";
export type UPDATE_API_URLS = typeof UPDATE_API_URLS;

export const RESET_SEARCH_PARAMS = "RESET_SEARCH_PARAMS";
export type RESET_SEARCH_PARAMS = typeof RESET_SEARCH_PARAMS;

export const UPDATE_SEARCH_PARAMS = "UPDATE_SEARCH_PARAMS";
export type UPDATE_SEARCH_PARAMS = typeof UPDATE_SEARCH_PARAMS;

// aPI calls

export const REQUEST_RESULTS = "REQUEST_RESULTS";
export type REQUEST_RESULTS = typeof REQUEST_RESULTS;

export const RECEIVE_RESULTS = "RECEIVE_RESULTS";
export type RECEIVE_RESULTS = typeof RECEIVE_RESULTS;

export const RECEIVE_RESULTS_FAILURE = "RECEIVE_RESULTS_FAILURE";
export type RECEIVE_RESULTS_FAILURE = typeof RECEIVE_RESULTS_FAILURE;

export const RECEIVE_DATE_RESULTS = "RECEIVE_DATE_RESULTS";
export type RECEIVE_DATE_RESULTS = typeof RECEIVE_DATE_RESULTS;

export const RECEIVE_SELECT_OPTION_RESULTS = "RECEIVE_SELECT_OPTION_RESULTS";
export type RECEIVE_SELECT_OPTION_RESULTS = typeof RECEIVE_SELECT_OPTION_RESULTS;


// actual statement - Delete the next one before checking in// 
export const DRRIP_AII_API ="/aii/api/"; 
export type DRRIP_AII_API = typeof DRRIP_AII_API;
   
export const DATA_REQUESTED = "DATA_REQUESTED";
export type DATA_REQUESTED = typeof DATA_REQUESTED;

export const DATA_LOADED = "DATA_LOADED";
export type DATA_LOADED = typeof DATA_LOADED;

export const REQUEST_IN_PROGRESS = "REQUEST_IN_PROGRESS";
export type REQUEST_IN_PROGRESS = typeof REQUEST_IN_PROGRESS;

export const RESET_FORM = "RESET_FORM";
export type RESET_FORM = typeof RESET_FORM;

export const SEARCH_FORM = "SEARCH_FORM";
export type SEARCH_FORM = typeof SEARCH_FORM;

// export const RECAPTCHA_SITE_KEY = "6Lef5MIfAAAAAHP4ke7UXTxTQf3KFfI62kRxacd1";
// export type RECAPTCHA_SITE_KEY = typeof RECAPTCHA_SITE_KEY; 


export const NOTICE_LINE1  = " This is a Federal Deposit Insurance Corporation (FDIC) computer system. This computer system may be" +
" monitored by the FDIC for lawful purposes. All information (including personal and confidential) " +
"placed on or sent over this system may be examined, recorded or copied, used or disclosed by the " +
"FDIC for authorized purposes. Any information collected during monitoring may be used for purposes "+
"of any administrative, civil or criminal action or proceeding.";

export const NOTICE_LINE2 =  " The Federal Deposit Insurance Act (12 U.S.C. §§ 1819, 1821, and 1822) and 12 C.F.R. Part 330 authorize the collection of this information." +  
"The purpose for collecting this information is to support the determination of deposit insurance coverage and/or the payment of deposit insurance " +
"on deposits of the closed financial institution.  Furnishing this information is voluntary but failure to provide the requested information in whole or " +
"in part may delay or prevent the determination of deposit insurance coverage and/or the payment of deposit insurance on deposits of the closed financial" +
"institution.  The information provided by individuals is protected by the Privacy Act, 5 U.S.C. 552a.  The information you provide may be provided to " +
"appropriate Federal, state, local or foreign law enforcement authorities; to a court, administrative tribunal, or a party in litigation; to contractors, " +
"agents and other third parties as authorized by law, and in accordance with any of the other routine uses described in the FDIC Unclaimed Deposit Account " +
"Records (FDIC-30-64-0024) System of Records.";
export const NOTICE_LINE3 = " A complete copy of this System of Records is available at" + "<a href=http://www.fdic.gov/about/privacy>www.fdic.gov/about/privacy</a>." +
" If you have questions or concerns about the collection or use of the information, you may contact the FDIC’s Chief Privacy Officer at <a href=mailto:Privacy@fdic.gov>Privacy@fdic.gov</a>.";


export const NOTICE_LINE4  = "Persons or entities that use or access the FDIC computer system without authorization or " +
"contrary to law may be subject to criminal prosecution.";
export const NOTICE_ACCEPT = "I Agree";
